<template>
  <component
    :is="component"
    class="col">
      <slot></slot>
  </component>
</template>

<script>

export default {
  name: 'col-elem',
  props: {
    'component': {
      type: String,
      default: 'div'
    }
  }
}
</script>

<style lang="sass">
.col
</style>
